'use client'

import { Image } from '@vinted/web-ui'

import { ShowAtBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

const AccesibilityFirstSection = () => {
  const translate = useTranslate('accessibility.first-section')
  const asset = useAsset('/assets/landing-pages/accessibility')

  return (
    <section className="accessibility-landingpage__first-section">
      <h1 className="accessibility-landingpage__first-section-title">{translate('title')}</h1>
      <p className="accessibility-landingpage__first-section-description">
        {translate('description')}
      </p>
      <div className="accessibility-landingpage__first-section-image">
        <ShowAtBreakpoint breakpoint="phones">
          <Image src={asset('first-section-mobile.png')} scaling="cover" alt={translate('title')} />
        </ShowAtBreakpoint>
        <ShowAtBreakpoint breakpoint="tabletsUp">
          <Image
            src={asset('first-section-desktop.png')}
            scaling="cover"
            alt={translate('title')}
          />
        </ShowAtBreakpoint>
      </div>
    </section>
  )
}

export default AccesibilityFirstSection
